import { useEffect, useState } from 'react';
import { useAuth } from '@/providers/AuthProvider';
import { fetchWaitingQuotes } from '@/services/quotes/waitingQuotes';
import { totalWaiting } from '@/utils/waitingQuotes';

// Number of quotes waiting for the signed-in customer, for the nav badges.
export const useWaitingQuoteCount = () => {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) {
      setCount(0);
      return;
    }
    let cancelled = false;
    fetchWaitingQuotes(user.id).then(byRequest => {
      if (!cancelled) setCount(totalWaiting(byRequest));
    });
    return () => {
      cancelled = true;
    };
  }, [user]);

  return count;
};
